import React from 'react';
import HomeOutlined from '@material-ui/icons/HomeOutlined';
import AssignmentOutlined from '@material-ui/icons/AssignmentOutlined';
import CropFreeOutlined from '@material-ui/icons/CropFreeOutlined';
import LocalShippingOutlined from '@material-ui/icons/LocalShippingOutlined';
import ContactsOutlined from '@material-ui/icons/ContactsOutlined';
import GroupAddOutlined from '@material-ui/icons/GroupAddOutlined';
import ListAltOutlined from '@material-ui/icons/ListAltOutlined';
import ReceiptOutlined from '@material-ui/icons/ReceiptOutlined';

/** Maps legacy icofont class names (constants/appNav.js) to MUI outlined icons — one icon
 * language in the app shell (docs/DESIGN_MAKEOVER.md 4.1/4.3). */
const ICON_MAP = {
  'icofont-ui-home': HomeOutlined,
  'icofont-calculator-alt-2': AssignmentOutlined,
  'icofont-barcode': CropFreeOutlined,
  'icofont-truck-alt': LocalShippingOutlined,
  'icofont-address-book': ContactsOutlined,
  'icofont-users-alt-5': GroupAddOutlined,
  'icofont-sub-listing': ListAltOutlined,
  'icofont-listing-box': ReceiptOutlined,
  'icofont-lens': CropFreeOutlined,
};

const NavIcon = ({ icon, fontSize = 'small', ...rest }) => {
  const Cmp = ICON_MAP[icon];
  if (!Cmp) return null;
  return <Cmp fontSize={fontSize} {...rest} />;
};

export default NavIcon;
